<template>
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <title>Flag / Region / Indonesia</title>
    <defs>
      <circle id="path-1" cx="12" cy="12" r="12"></circle>
    </defs>
    <g
      id="Flag-/-Region-/-Indonesia"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <mask id="mask-2" fill="white">
        <use xlink:href="#path-1"></use>
      </mask>
      <g id="Mask" fill-rule="nonzero"></g>
      <g id="id" mask="url(#mask-2)">
        <polygon
          id="Path"
          fill="#E70011"
          points="0 0 24 0 24 12.4453125 0 12.4453125"
        ></polygon>
        <polygon
          id="Path"
          fill="#FFFFFF"
          points="0 12 24 12 24 24 0 24"
        ></polygon>
      </g>
    </g>
  </svg>
</template>

<script>
export default {};
</script>

<style>
</style>